module.exports = __webpack_public_path__ + "assets/images/animations/ebay-animation.png?63edcb69";